import { render, staticRenderFns } from "./lifeCycle-preview-dialog.vue?vue&type=template&id=1b59a7c8&scoped=true"
import script from "./lifeCycle-preview-dialog.vue?vue&type=script&lang=js"
export * from "./lifeCycle-preview-dialog.vue?vue&type=script&lang=js"
import style0 from "./lifeCycle-preview-dialog.vue?vue&type=style&index=0&id=1b59a7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59a7c8",
  null
  
)

export default component.exports